import React from 'react';
import IconName from "../../../../svgLogo/SvgLogo";

const ProgressBuy = () => {
    return (
        <div className="progress-buy-wrapper xmt-8">
            <div id="step-buy-progress" className="name-step d-flex justify-content-around align-items-center">
                <div className="progress-success"></div>
                <div className="name-item d-flex align-items-center flex-column before">
                    <div className="name xmb-2 xmb-lg-3 d-flex align-items-center flex-column flex-lg-row">
                        <IconName name="monetization_on"
                                  className="icon xml-1"/>
                        <span className="text">پرداخت</span>
                    </div>
                    <div className="status-item"><IconName name="step_circle" className="icon"/></div>
                </div>
                <div className="name-item d-flex align-items-center flex-column before">
                    <div className="name xmb-2 xmb-lg-3 d-flex align-items-center flex-column flex-lg-row">
                        <IconName name="widgets"
                                  className="icon xml-1"/>
                        <span className="text d-none d-lg-inline-block">آماده سازی</span>
                        <span className="text d-inline-block d-lg-none">تامین</span>
                    </div>
                    <div className="status-item"><IconName name="step_circle" className="icon"/></div>
                </div>
                <div className="name-item d-flex align-items-center flex-column active">
                    <div className="name xmb-2 xmb-lg-3 d-flex align-items-center flex-column flex-lg-row">
                        <IconName name="package"
                                  className="icon pack xml-1"/>
                        <span className="text">بسته بندی</span>
                    </div>
                    <div className="status-item"><IconName name="step_circle" className="icon"/></div>
                </div>
                <div className="name-item d-flex align-items-center flex-column after">
                    <div className="name xmb-2 xmb-lg-3 d-flex align-items-center flex-column flex-lg-row">
                        <IconName name="local_shipping"
                                  className="icon xml-1"/>
                        <span className="text">ارسال</span>
                    </div>
                    <div className="status-item"><IconName name="step_circle" className="icon"/></div>
                </div>
                <div className="name-item d-flex align-items-center flex-column after">
                    <div className="name xmb-2 xmb-lg-3 d-flex align-items-center flex-column flex-lg-row">
                        <IconName name="check_circle"
                                  className="icon xml-1"/>
                        <span className="text d-none d-lg-inline-block">تکمیل شده</span>
                        <span className="text d-inline-block d-lg-none">تکمیل</span>
                    </div>
                    <div className="status-item"><IconName name="step_circle" className="icon"/></div>
                </div>
            </div>
        </div>
    );
};

export default ProgressBuy;
